import React, { useState } from 'react';
import './Features.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faBullhorn, faUsers, faRobot } from '@fortawesome/free-solid-svg-icons';
import Modal from './Modal';

const Features = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});
  
  
  const publicationsData = [
    {
      title: "Grape farm pest bird sound detection system using embedded systems",
      authors: "E. Aman, Wen-Ren Yang",
      date: "October 2023",
      description: "E. Aman and W. . -R. Yang, Grape farm pest bird sound detection system using embedded systems, IET International Conference on Engineering Technologies and Applications (ICETA 2023), Yunlin, Taiwan, 2023, pp. 13-14, doi: 10.1049/icp.2023.3167.",
      link: "https://ieeexplore.ieee.org/document/10461214"
  },
    {
      title: "Textile Production Line Monitoring System Using Wavelet-Regression Neural Network",
      authors: "Vinothkumar Veeramani, Nagaraj Dharwadkar, Anagha R. Pakhare, Wen-Ren Yang",
      date: "January 2022",
      description: "This paper presents design and experiments for a production line monitoring system. The system is designed based on an existing production line which mapping to the smart grid standards. The Discrete wavelet transform (DWT) and regression neural network (RNN) are applied to the operation modes data analysis. DWT used to preprocess the signals to remove noise from the raw signals. The output of DWT energy distribution has given as an input to the GRNN model. The neural network GRNN architecture involves multi-layer structures. Mean Absolute Percentage Error (MAPE) loss has used in the GRNN model, which is used to forecast the time-series data. Current research results can only apply to the single production line but in future, it will used for multiple production lines.",
      link: "https://www.researchgate.net/publication/361671096_Textile_Production_Line_Monitoring_System_Using_Wavelet-Regression_Neural_Network?_tp=eyJjb250ZXh0Ijp7InBhZ2UiOiJzY2llbnRpZmljQ29udHJpYnV0aW9ucyIsInByZXZpb3VzUGFnZSI6bnVsbH19"
  },
  
    {
      title: "Optimizing the on-chip electrostatic discharge protection device by Taguchi's methodology",
      authors: "S.-C. Huang, Wen-Ren Yang, Chau-Shing Wang Jing-Er Chiu",
      date: "Published in 2022",
      description: "The study presents the use of Taguchi method to obtain the best ESD performance devices and compares the performance with other methods. A full-factor method to obtain the best ESD performance devices can achieve all experimental factor effects, but at a significant cost. Through silicon data validation and analysis, Taguchi's method has been shown to save two-thirds of the cost for optimal ESD devices compared to the full-factor approach. In addition, if the layout area is very concerned in advanced technologies such as 40 nm and 28 nm, a tentative method called the single-factor-middle-level method is proposed as another ESD device optimization method.",
      link: "https://www.researchgate.net/publication/362302486_Optimizing_the_on-chip_electrostatic_discharge_protection_device_by_Taguchi's_methodology?_tp=eyJjb250ZXh0Ijp7InBhZ2UiOiJzY2llbnRpZmljQ29udHJpYnV0aW9ucyIsInByZXZpb3VzUGFnZSI6bnVsbH19"
  },
    {
        title: "Enhancement of the Flickermeter for Grid-Connected Wind Turbines",
        authors: "Wen-Ren Yang",
        date: "Published in 2021",
        description: "Distributed generators connected to the power system usually produce voltage fluctuations...",
        link: "https://www.researchgate.net/publication/354581371_Enhancement_of_the_Flickermeter_for_Grid-Connected_Wind_Turbines?_tp=eyJjb250ZXh0Ijp7InBhZ2UiOiJzY2llbnRpZmljQ29udHJpYnV0aW9ucyIsInByZXZpb3VzUGFnZSI6bnVsbH19"
    },
    {
        title: "Motion-Pattern Recognition System Using a Wavelet-Neural Network",
        authors: "Wen-Ren Yang",
        date: "January 2019",
        description: "W. -R. Yang, C. -S. Wang and C. -P. Chen, Motion-Pattern Recognition System Using a Wavelet-Neural Network...",
        link: "https://ieeexplore.ieee.org/document/8625510/"
    },
    {
        title: "Discrete Wavelet Transform and Radial Basis Neural Network for Semiconductor Wet-Etching Fabrication Flow-Rate Analysis",
        authors: "Wen-Ren Yang",
        date: "April 2012",
        description: "W. -R. Yang, Discrete Wavelet Transform and Radial Basis Neural Network for Semiconductor Wet-Etching Fabrication Flow-Rate Analysis...",
        link: "https://ieeexplore.ieee.org/document/6125246/"
    },
    {
        title: "Current Measurement of Resistance Spot Welding Using DSP",
        authors: "Wen-Ren Yang, Chau-Shing Wang",
        date: "March 2011",
        description: "This research develops a method using DSP (Digital Signal Processing) to measure welding current in real-time...",
        link: "https://www.researchgate.net/publication/228900743_Current_Measurement_of_Resistance_Spot_Welding_Using_DSP"
    },
    
    {
        title: "Optical design and signal processing for a microcrack detection system",
        authors: "Wen-Ren Yang",
        date: "July 2010",
        description: "This paper presents optical design, proof-of-principle experiments, and post-signal processing...",
        link: "https://www.researchgate.net/publication/224158294_Optical_design_and_signal_processing_for_a_microcrack_detection_system?_tp=eyJjb250ZXh0Ijp7InBhZ2UiOiJzY2llbnRpZmljQ29udHJpYnV0aW9ucyIsInByZXZpb3VzUGFnZSI6bnVsbH19"
    },
    
    {
        title: "Discrete wavelet transform and short-time fourier transform applications: Wafer microcrack and voltage sag detection",
        authors: "Wen-Ren Yang, Wen-Xun Yang",
        date: "July 2010",
        description: "This paper presents discrete wavelet transform (DWT) and short-time fourier transform (STFT) applications...",
        link: "https://www.researchgate.net/publication/251946575_Discrete_wavelet_transform_and_short-time_fourier_transform_applications_Wafer_microcrack_and_voltage_sag_detection?_tp=eyJjb250ZXh0Ijp7InBhZ2UiOiJzY2llbnRpZmljQ29udHJpYnV0aW9ucyIsInByZXZpb3VzUGFnZSI6bnVsbH19"
    },
    {
        title: "Application of image processing to wafer probe mark area calculation",
        authors: "Chau-Shing Wang; Wen-Ren Yang; Cheng-Yen Chung; Wen-Liang Chang",
        date: "July 2010",
        description: "C. -S. Wang, W. -R. Yang, Cheng-Yen Chung and Wen-Liang Chang, Application of image processing to wafer probe mark area calculation...",
        link: "https://ieeexplore.ieee.org/document/5516928/"
    },
    {
        title: "Current-Shared Photovoltaic Power System",
        authors: "Liang-Rui Chen; Chung-Ming Young; Neng-Yi Chu; Ruey-Hsun Liang; Wen-Ren Yang",
        date: "July 2010",
        description: "L. -R. Chen, C. -M. Young, N. -Y. Chu, R. -H. Liang and W. -R. Yang, Current-Shared Photovoltaic Power System...",
        link: "https://ieeexplore.ieee.org/document/5542360/"
    },
    {
        title: "Interleaved LLC series converter with output voltage doubler",
        authors: "Wen-Ren Yang",
        date: "June 2010",
        description: "B. -R. Lin, W. -R. Yang, J. -J. Chen, C. -L. Huang and M. -H. Yu, Interleaved LLC series converter with output voltage doubler...",
        link: "https://ieeexplore.ieee.org/document/5543842/"
    },
    {
      title: "LLC Series Resonant High-Frequency Sinusoidal Power Supplier",
      authors: "Liang-Rui Chen, Chung-Ming Young, Hai-Wen Chang, Wen-Ren Yang",
      date: "November 2010",
      description: "This paper presents an LLC series resonant high-frequency sinusoidal power supplier for contactless power transmission system utilizing the magnetizing inductance and the leakage inductance of contactless coupled transformer. The design of system's parameters is under 2mm air gap of contactless coupled transformer and utilizes microchip dsPIC30F4011 to track resonance tank voltage and current phase in order to maintain operation of circuit resonant frequency to ensure that circuit can provide maximum power output for various loads. Finally, a 1kW prototype is designed and implemented to access the performance of the proposed LLC series resonant high-frequency sinusoidal power supplier. The proposed circuit also compares with the traditional frequency fixed high-frequency sinusoidal power supplier. The experimental result shows that the proposed circuit can provide maximum power output for various loads and the efficiency is about 95%.",
      link: "https://www.researchgate.net/publication/261042373_LLC_Series_Resonant_High-Frequency_Sinusoidal_Power_Supplier?_tp=eyJjb250ZXh0Ijp7InBhZ2UiOiJzY2llbnRpZmljQ29udHJpYnV0aW9ucyIsInByZXZpb3VzUGFnZSI6bnVsbH19"
  },
  {
    title: "Detecting of optimal Li-ion battery charging frequency by using AC impedance technique",
    authors: "Liang-Rui Chen, Shing-Lih Wu, Tsair-Rong Chen, Wen-Ren Yang",
    date: "June 2009",
    description: "This paper aims to explore the optimal Li-ion battery charging frequency by using AC impedance technique. The experiment proves that the optimal charging frequency is the point of the minimum AC impedance. In such a situation of the battery charged by the optimal charging frequency, the charging time and charging efficiency are improved above 30.68% and 30.6%.",
    link: "https://www.researchgate.net/publication/224546234_Detecting_of_optimal_Li-ion_battery_charging_frequency_by_using_AC_impedance_technique?_tp=eyJjb250ZXh0Ijp7InBhZ2UiOiJzY2llbnRpZmljQ29udHJpYnV0aW9ucyIsInByZXZpb3VzUGFnZSI6bnVsbH19"
},
    {
        title: "Short-Time Discrete Wavelet Transform for wafer microcrack detection",
        authors: "Wen-Ren Yang",
        date: "August 2009",
        description: "This paper presents design and proof-of-principle experiments for a real-time in-line wafer microcrack detection system...",
        link: "https://www.researchgate.net/publication/224581679_Short-Time_Discrete_Wavelet_Transform_for_wafer_microcrack_detection?_tp=eyJjb250ZXh0Ijp7InBhZ2UiOiJzY2llbnRpZmljQ29udHJpYnV0aW9ucyIsInByZXZpb3VzUGFnZSI6bnVsbH19"
    },
    {
        title: "Study of a contactless power transmission system",
        authors: "Wen-Ren Yang",
        date: "August 2008",
        description: "This paper discusses the contactless power transmission system...",
        link: "https://www.researchgate.net/publication/224349849_Study_of_a_contactless_power_transmission_system?_tp=eyJjb250ZXh0Ijp7InBhZ2UiOiJzY2llbnRpZmljQ29udHJpYnV0aW9ucyIsInByZXZpb3VzUGFnZSI6bnVsbH19"
    },
    {
        title: "Analysis of equivalent 10-Hz voltage flicker measurement using IEC flickermeter standard",
        authors: "Wen-Ren Yang",
        date: "2008 IEEE International Conference on Industrial Technology",
        description: "C. . -S. Wang, L. . -R. Chen and W. . -R. Yang, Analysis of equivalent 10-Hz voltage flicker measurement using IEC flickermeter standard...",
        link: "https://ieeexplore.ieee.org/document/4608658"
    },
    {
        title: "Modeling of a wavelet-based voltage sag monitoring system and design for the mixed-signal integrated circuit implementation",
        authors: "Wen-Ren Yang",
        date: "May 2008",
        description: "This paper presents a design and simulation for the voltage sag monitoring technique...",
        link: "https://www.researchgate.net/publication/4365867_Modeling_of_a_wavelet-based_voltage_sag_monitoring_system_and_design_for_the_mixed-signal_integrated_circuit_implementation?_tp=eyJjb250ZXh0Ijp7InBhZ2UiOiJzY2llbnRpZmljQ29udHJpYnV0aW9ucyIsInByZXZpb3VzUGFnZSI6bnVsbH19"
    },
    {
        title: "Optical and Thermal Analysis for a Modified Flip-Chip Light Emitting Diode",
        authors: "Chuen-Ching Wang; Wen-Ren Yang; Jin-Jia Chen; Wei-Wen Shih; I-Ju Wang; Tsung-Yi Guo; Kwang-Long Huang",
        date: "January 2008",
        description: "C. -C. Wang et al., Optical and thermal analysis for a modified flip-chip Light Emitted Diode...",
        link: "https://ieeexplore.ieee.org/document/5348753/"
    },
    
    {
      title: "Objective lens and spatial filter array in an electrooptic analog-to-digital converter",
      authors: "Wen-Ren Yang, Bo-Jao Huang, William Nunnally",
      date: "August 2007",
      description: "This research presents the design and proof-of-principle experiment for an electrooptic analog-to-digital converter. An objective lens designed in order to focus the optical pulse deflected by the electrooptic deflection and bi-wedge diffraction of the near-field spatial filter array will be discussed.",
      link: "https://www.researchgate.net/publication/241151977_Objective_lens_and_spatial_filter_array_in_an_electrooptic_analog-to-digital_converter?_tp=eyJjb250ZXh0Ijp7InBhZ2UiOiJzY2llbnRpZmljQ29udHJpYnV0aW9ucyIsInByZXZpb3VzUGFnZSI6bnVsbH19"
  },
    {
        title: "Flywheel energy storage system for voltage sag compensation",
        authors: "W. R. Yang; M. H. Hu; G. W. Jhang; Z. Y. He; K. Y. Huang; C. S. Wang; L. R. Chen; T. Y. Guo; C. P. Young",
        date: "May 2005",
        description: "W. R. Yang et al., Flywheel energy storage system for voltage sag compensation...",
        link: "https://ieeexplore.ieee.org/document/5385831/"
    },
    {
        title: "A novel bidirectional converter with the reflex charging function",
        authors: "L. R. Chen; C. S. Wang; W. R. Yang; N. Y. Chu",
        date: "2004 IEEE Transactions on Industrial Electronics",
        description: "L. R. Chen et al., A novel bidirectional converter with the reflex charging function...",
        link: "https://ieeexplore.ieee.org/document/5364563/"
    },
    {
      title: "Overview of an all-optical analog-to-digital converter, focusing of deflected TeraHertz optical pulse and propagation characteristics",
      authors: "Wen-Ren Yang, Timothy Renkoski, William Nunnally",
      date: "May 2005",
      description: "The Advanced Radars and Electro-Optical Sensors group at the University of Missouri is constructing a new all-optical analog-to-digital converter (ADC) platform. This integrated optics application especially suits the data acquisition and processing requirements of mobile sensor systems that have dramatically increased alongside the requirements for reductions in system mass, volume, and power consumption. The platform of the ADC is composed of a direct-modulated laser (DML) at λ = 1.55 μm with a 40 G bits/sec sampling optical pulse source; a prism LiTaO3 (lithium tantalate) electro-optical deflector; an integrated focusing unit; a three-dimensional binary-coded spatial filter array; and collection optics. Using discrete Fourier transform, we also investigate both the center frequency-shifting phenomenon of the optical pulse propagation, and the frequency response. The simulations are calculated by using the two-dimensional Finite Difference Time Domain (FDTD) method, the results of which are much more reliable than Beam Propagation Methods (BPM). The spatial filter array and collection optics will be fabricated by the separated implanted oxygen process (SIMOX), silicon on insulator (SOI). Also, a new design and simulation of LiTaO3 (lithium tantalate) electro-optical deflector to be integrated in the same substrate is proposed. This platform is to be tested for 50 Giga-samples/sec analog-to-digital conversion, and be the prototype of a 100 Giga-samples/sec ADC.",
      link: "https://www.researchgate.net/publication/259306877_Overview_of_an_all-optical_analog-to-digital_converter_focusing_of_deflected_TeraHertz_optical_pulse_and_propagation_characteristics?_tp=eyJjb250ZXh0Ijp7InBhZ2UiOiJzY2llbnRpZmljQ29udHJpYnV0aW9ucyIsInByZXZpb3VzUGFnZSI6bnVsbH19"
  }
];


  const featuresData = [
    {
      title: "AI Project Showcase",
      description: "Demo Videos & Results",
      bgColor: "#a3d2fc",
      buttonText: "Learn More",
      icon: faMagnifyingGlass,
      details: "Detailed description of AI Project Showcase...",
      links: [
        { text: 'IIPP', url: 'https://iipp.tw/' },
        { text: 'TEEP', url: 'https://teep.studyintaiwan.org/' },
        { text: 'Tairos', url: 'https://www.tairos.tw/en/' }
        
      ],
      images: [
        { src: 'https://i.ibb.co/sqZbpms/477ceee231bd.png', alt: 'Project Screenshot 1' },
        { src: 'https://i.ibb.co/FwXbW4v/aa9c75246814.png', alt: 'Project Screenshot 2' },
      ],
      pdfLinks: [
        { text: "IIPP_NCUE_wry87c_2024.pdf", url: "IIPP_NCUE_wry87c_2024.pdf" },
        { text: "TEEP_NCUE_wry87c_2023_SDG7_1.pdf", url: "TEEP_NCUE_wry87c_2023_SDG7_1.pdf" } // Link to the PDF in public folder
      ]
    },
    {
      title: "Publications and Resources",
      description: "Research papers",
      bgColor: "#88e5c3",
      buttonText: "Learn More",
      icon: faBullhorn,
      details: "More information about our publications and resources...",
      publications: publicationsData
    },
    {
      title: "Team and Collaborations",
      description: "Introduction to our team!",
      bgColor: "#d1d1d1",
      buttonText: "Learn More",
      icon: faUsers,
      details: "Meet our team and learn about our collaborations...",
    },
    {
      title: "Interactive AI Demo",
      description: "Try our AI demos!",
      bgColor: "#fa8072",
      buttonText: "Learn More",
      icon: faRobot,
      details: "Explore interactive AI demos and applications...",
    }
  ];

  const handleLearnMore = (feature) => {
    setModalContent(feature);
    setShowModal(true);
  };

  return (
    <section className="features-section">
      <div id="features" className="container">
        <h2>Our Key Features</h2>
        <div className="features-grid">
          {featuresData.map((feature, index) => (
            <div
              key={index}
              className="feature-item"
              style={{ backgroundColor: feature.bgColor }}
            >
              <div className="feature-icon">
                <FontAwesomeIcon icon={feature.icon} size="2x" />
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
              <button
                className="feature-button"
                onClick={() => handleLearnMore(feature)}
              >
                {feature.buttonText}
              </button>
            </div>
          ))}
        </div>
      </div>
      <Modal
        show={showModal}
        onClose={() => setShowModal(false)}
        title={modalContent.title}
        description={modalContent.details}
        publications={modalContent.publications}
        links={modalContent.links}
        images={modalContent.images}
        pdfLinks={modalContent.pdfLinks} // Added to pass pdfLinks
      />
    </section>
  );
};

export default Features;
